//this will make jquery global and make it compatible with dependant modules
window.$ = window.jQuery = require('jquery');

//boostrap
require('bootstrap');
//required initialization of bootstrap popovers
$(function () {
    $('[data-toggle="popover"]').popover()
})

//jquery validation
require('jquery-validation');

//sticky JS + initializer
window.Sticky = require('sticky-js');
window.Sticky = new Sticky('[data-sticky]');

//debounce//throttle
window.debounce = require('lodash.debounce');
window.throttle = require('lodash.throttle'); 

//mark.js
window.Mark = require('mark.js');

//match height
import MatchHeight from '@tannerhodges/match-height';

//global flag
//var debug = true;

//C# esque string.format function
String.format = function () {
    // The string containing the format items (e.g. "{0}")
    // will and always has to be the first argument.
    var theString = arguments[0];

    // start with the second argument (i = 1)
    for (var i = 1; i < arguments.length; i++) {
        // "gm" = RegEx options for Global search (more than one instance)
        // and for Multiline search
        var regEx = new RegExp("\\{" + (i - 1) + "\\}", "gm");
        theString = theString.replace(regEx, arguments[i]);
    }

    return theString;
}

//detect and emit pushstate event
var _wr = function (type) {
    var orig = history[type];
    return function () {
        var rv = orig.apply(this, arguments);
        var e = new Event(type);
        e.arguments = arguments;
        window.dispatchEvent(e);
        return rv;
    };
};
history.pushState = _wr('pushState'), history.replaceState = _wr('replaceState');

//$(window).on('pushState', function () {
//    //console.debug('history state alteration detected');
//});

//TODO experimental - currently fails by replacing entire parent with number in some cases
//uses XPath to identify phone numbers that aren't tel: links, and wraps them with an <a href="tel:{x}"></a>
//https://stackoverflow.com/questions/34406508/javascript-replace-all-phone-numbers-not-already-in-links-to-click-to-call-l
//function autoLinkPhoneNumbers() {
//    var xpr = document.evaluate('descendant-or-self::text()[not(parent::A) and string-length(normalize-space(self::text())) >= 12]',
//        document.body, null, XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE, null);
//    for (var i = 0, len = xpr.snapshotLength; i < len; ++i) {
//        var txt = xpr.snapshotItem(i);
//        // Splits with grouping to preserve the text split on
//        var numbers = txt.data.split(/([(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4})/);
//        // split will return at least three items on a hit, prefix, split match, and suffix
//        if (numbers.length >= 3) {
//            var parent = txt.parentNode; // Save parent before replacing child

//            if (!parent)
//                continue;

//            // Replace contents of parent with text before first number
//            parent.textContent = numbers[0];

//            // Now explicitly create pairs of anchors and following text nodes
//            for (var i = 1; i < numbers.length; i += 2) {
//                // Operate in pairs; odd index is phone number, even is 
//                // text following that phone number
//                var anc = document.createElement('a');
//                anc.href = 'tel:' + numbers[i].replace(/\D+/g, '');
//                anc.textContent = numbers[i];
//                parent.appendChild(anc);
//                parent.appendChild(document.createTextNode(numbers[i + 1]));
//            }
//            parent.normalize(); // Normalize whitespace after rebuilding
//        }
//    }
//}

//non working concept to force pasting of plain text to EE single line text style fields
//successfully pastes as plain text, but sitecore still performs its own (obfuscated) paste injection (despite attempts at stoppropagation), doubling the pasting, with the second paste including the markup
//$('.scWebEditInput').on('paste', function (e) {
//    e.originalEvent.preventDefault();
//    //var clipBoardData = e.originalEvent.clipboardData;
//    //var content = clipBoardData.getData('text/plain');
//    //document.execCommand('insertText', false, content);
//    //return false;

//    var text = '';
//    if (e.clipboardData || e.originalEvent.clipboardData) {
//        text = (e.originalEvent || e).clipboardData.getData('text/plain');
//    } else if (window.clipboardData) {
//        text = window.clipboardData.getData('Text');
//    }
//    if (document.queryCommandSupported('insertText')) {
//        document.execCommand('insertText', false, text);
//    } else {
//        document.execCommand('paste', false, text);
//    }

//    return false;
//});

window.distance = function (lat1, lon1, lat2, lon2, unit) {
    if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
    }
    else {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit == "K") { dist = dist * 1.609344 }
        if (unit == "N") { dist = dist * 0.8684 }
        return dist;
    }
}

function scrollHorizontally(e, target) {
    e = window.event || e;
    var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
    target.scrollLeft -= (delta * 40); // Multiplied by 40
    e.preventDefault();
}

$(document).ready(function () {
    $('[data-horizontal-scrollable]').each(function () {
        $(this).on('mousewheel DOMMouseScroll', function (e) {
            scrollHorizontally(e, $(this)[0]);
        });
    });

    //SuperscriptReg();
});

//TODO - abstract this to take in any number of symbols
/*function SuperscriptReg() {

    if (!IsExperienceEditor) {
        var regexp = /[\xAE]/;
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3 && (regexp.test(this.nodeValue));
        }).replaceWith(function () {
            return this.nodeValue.replace(regexp, '<sup>$&</sup>');
        });
    }
}*/

window.changeUrlHash = function (hashValue, changeHistory) {

    if (!hashValue)
        return;

    if (hashValue.startsWith('#')) {
        hashValue = hashValue.substring(1);
    }

    if (changeHistory) {
        history.pushState(null, null, '#' + hashValue);
    }
    else {
        window.location.hash = hashValue;
    }
}

window.CenteredPopup = function (url, windowName, w, h) {
    const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
    const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);
    return window.open(url, windowName, `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
}

//custom scripts
require('./custom/jquery-extensions.js');
require('./custom/sticky.js');
require('./custom/cookies.js');
require('./custom/header.js');
require('./custom/in-page-navigation.js');
require('./custom/smooth-scroll.js');
require('./custom/forms.js');
require('./custom/dropdown.js');
require('./custom/search.js');
require('./custom/youtube.js');
require('./custom/geolocation.js');
require('./custom/modal.js');
require('./custom/debug.js');
require('./custom/bootstrap-extensions.js');
require('./custom/blog.js');
require('./custom/animations.js');
require('./custom/accordion.js');